
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.47 20.504c-1.54 0-2.5-1.67-1.73-3l7.53-13.01c.77-1.33 2.69-1.33 3.46 0l7.53 13.01c.77 1.33-.19 3-1.73 3H4.47zm15.06-2L12 5.494l-7.53 13.01h15.06zM11 10.754v2.5c0 .687.45 1.25 1 1.25s1-.563 1-1.25v-2.5c0-.688-.45-1.25-1-1.25s-1 .562-1 1.25zm1 4.75a1 1 0 100 2 1 1 0 000-2z","fill":"#F79539"}})])
          )
        }
      }
    